import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navLinksRef = useRef(null);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (navLinksRef.current && !navLinksRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const whatsappDirect = 'https://wa.me/50686191589?text=' + encodeURIComponent('Hola Sol de Vainilla, me gustaría información sobre sus servicios de consultoría y productos.');

  return (
    <header className="header-wrapper">
      {/* Top Bar matching reference image */}
      <div className="top-bar">
        <div className="top-bar-container">
          <div className="top-bar-contact">
            <a href="mailto:gaby@soldevainilla.com" className="top-bar-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
              <span>gaby@soldevainilla.com</span>
            </a>
            <a href="tel:+50686191589" className="top-bar-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              <span>+506 8619 1589</span>
            </a>
            <div className="top-bar-item location-tag">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>Costa Rica</span>
            </div>
          </div>

          <div className="top-bar-socials">
            <a href="https://instagram.com/mariag2589" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
              </svg>
            </a>
            <a href="https://facebook.com/profile.php?id=61571459882189" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            <a href={whatsappDirect} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="social-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar with logo.png and Slogan */}
      <nav className="navbar">
        <div className="navbar-container">
          <div className="logo">
            <Link to="/" className="logo-link">
              <img src="/Logo.jpeg" alt="Sol de Vainilla" className="logo-img" />
              <div className="logo-brand-info">
                <span className="logo-title">Sol de Vainilla</span>
                <span className="logo-slogan">Con vainilla siempre sí!</span>
              </div>
            </Link>
          </div>

          <button className={`menu-icon ${menuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Abrir Menú">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </button>

          <div className={`nav-links ${menuOpen ? 'active' : ''}`} ref={navLinksRef}>
            <ul>
              <li>
                <Link to="/" className={location.pathname === '/' ? 'active-link' : ''}>
                  Inicio
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className={`nav-consultoria ${location.pathname === '/servicios' || location.pathname === '/consultoria' ? 'active-link' : ''}`}
                >
                  Consultoría y Servicios
                </Link>
              </li>
              <li>
                <Link to="/productos" className={location.pathname === '/productos' ? 'active-link' : ''}>
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/blog" className={location.pathname === '/blog' ? 'active-link' : ''}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/beneficios" className={location.pathname === '/beneficios' ? 'active-link' : ''}>
                  Beneficios
                </Link>
              </li>
              <li>
                <Link to="/contacto" className={location.pathname === '/contacto' ? 'active-link' : ''}>
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;